module.exports = __webpack_public_path__ + "img/img_banner_sort01.83857515.svg";